import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../auth.service';
import { EnvironmentService } from '../../../services/environment.service';
import { AppState } from 'src/app/state/reducers';
import { Store } from '@ngrx/store';
import { GetUserPractices } from 'src/app/practices/state/actions';
import { Router } from '@angular/router';
import {GetUnreadHelpPosts} from '../../state/actions';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthPage implements OnInit, OnDestroy {
  returnUrl: string;
  alive = true;
  oneSignalUserId: string | null = null;

  constructor(
    private authService: AuthService,
    private environmentService: EnvironmentService,
    private store: Store<AppState>,
    private router: Router,
    private titleService: Title,
  ) {
    const title = 'Digital Practice | Login';
    this.titleService.setTitle(title);

    this.returnUrl = window.localStorage.getItem('returnUrl') ?? '/day-list';
    window.localStorage.removeItem('returnUrl');
  }

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    if (code && state) {
      if (state === window.localStorage.getItem('state')) {
        const params = {
          grant_type: 'authorization_code',
          client_id: this.environmentService.get('authClientId'),
          redirect_uri: this.environmentService.get('appUrl') + '/auth/callback',
          code_verifier: window.localStorage.getItem('verifier'),
          code
        };

        this.authService.getToken(params).subscribe(() => {
          this.authService.getJwt(true).subscribe((response) => {
            window.localStorage.removeItem('state');
            window.localStorage.removeItem('verifier');
            this.store.dispatch(GetUserPractices());
            this.redirectOnAuth();
            this.getUserOnAuth();
          }, (error) => {
            console.log(error);
          });
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  redirectOnAuth(): void {
    if (this.returnUrl == '' || this.returnUrl == 'undefined') {
      this.returnUrl = '/day-list';
    }

    this.router.navigateByUrl(this.returnUrl);
  }

  getUserOnAuth(): void {
    this.authService.getAndStoreUser();
    this.store.dispatch(GetUnreadHelpPosts());
  }
}
